
let rootFontSize = 0;

// 横線の位置を画像の配置位置から計算して返す
export function AdjustLineXPos(imgPos: number)
{
    if (matchMedia('(max-width: 768px)').matches)
    {
        return imgPos + 1.1;
    }
    else
    {
        return imgPos + 0.91;
    }
}

// 縦の矢印の長さを一番下の画像位置から計算して割り出す
export function SetArrowHeight(imgPosRem: number)
{
    // before要素のサイズ取得
    const before = document.querySelector('.arrow');
    let beforeRem = 0;
    if (before != undefined)
    {
        let beforeHeight = parseFloat(window.getComputedStyle(before, ":before").height);
        beforeRem = beforeHeight / rootFontSize;

        // 少数第2位までで四捨五入
        beforeRem = Math.round(beforeRem * 100) / 100;

        // before要素分引いて隙間を開けるために加算
        if (matchMedia('(max-width: 768px)').matches)
        {
            return imgPosRem - beforeRem + 0.2;
        }
        else
        {
            return imgPosRem - beforeRem + 0.52;
        }
    }
    else
    {
        return 0;
    }
}

// パネルを配置する位置を計算してrem単位で返す
export function GetPanelPositionRem(clientHeight: number, beforeHeight: number, checkHeight: number)
{
    // 基準となるフォントサイズの取得
    const root = document.documentElement;
    let style = window.getComputedStyle(root).getPropertyValue('font-size');
    rootFontSize = parseFloat(style);

    let heightRem = clientHeight / rootFontSize;
    let beforeTopRem = beforeHeight / rootFontSize;
    let checkRem = checkHeight / rootFontSize;

    if (matchMedia('(max-width: 768px)').matches)
    {
        return Math.round((heightRem + beforeTopRem + 0.4) * 100) / 100
    }
    else
    {
        let topRem = (heightRem + beforeTopRem) - 3.33;
    
        // 上の画像とがぶっていないかチェック
        if (checkRem > 0)
        {
            // 被っているのでずらす
            if (checkRem > topRem)
            {
                topRem = checkRem + 0.51;
            }
        }
        
        return Math.round(topRem * 100) / 100;
    }
}